{
  "page": {
    "title": "ลูกค้าสัมพันธ์",
    "subtitle": "จัดการข้อมูลและติดตามลูกค้าทั้งหมด"
  },
  "table": {
    "title": "รายชื่อลูกค้า",
    "totalCustomers_other": "ทั้งหมด {{count}} ราย",
    "noCustomers": "ยังไม่มีลูกค้า",
    "add": "เพิ่มลูกค้า",
    "search": "ค้นหาชื่อ, อีเมล, เบอร์โทร...",
    "filterTags": "กรองตามแท็ก",
    "customer": "ลูกค้า",
    "email": "อีเมล",
    "phone": "เบอร์โทร",
    "tags": "แท็ก",
    "createdAt": "สร้างเมื่อ",
    "totalItems_other": "ทั้งหมด {{count}} รายการ",
    "empty": "ไม่พบข้อมูลลูกค้า"
  },
  "create": {
    "title": "เพิ่มลูกค้าใหม่",
    "success": "เพิ่มลูกค้าสำเร็จ",
    "failed": "เพิ่มลูกค้าไม่สำเร็จ",
    "displayName": "ชื่อที่แสดง",
    "displayNameRequired": "กรุณาระบุชื่อที่แสดง",
    "displayNameExample": "เช่น คุณสมชาย",
    "email": "อีเมล",
    "emailInvalid": "รูปแบบอีเมลไม่ถูกต้อง",
    "phone": "เบอร์โทร",
    "tags": "แท็ก",
    "tagsPlaceholder": "พิมพ์แล้ว Enter เพื่อเพิ่มแท็ก",
    "cancel": "ยกเลิก",
    "add": "เพิ่มลูกค้า"
  },
  "drawer": {
    "editTitle": "แก้ไขลูกค้า",
    "title": "ข้อมูลลูกค้า",
    "edit": "แก้ไข",
    "saveSuccess": "บันทึกข้อมูลสำเร็จ",
    "saveFailed": "บันทึกข้อมูลไม่สำเร็จ",
    "deleteSuccess": "ลบลูกค้าแล้ว",
    "deleteFailed": "ลบลูกค้าไม่สำเร็จ",
    "deleteTitle": "ลบลูกค้านี้?",
    "deleteDetail": "รายชื่อจะถูกซ่อนจากระบบ ประวัติการสนทนาและออเดอร์ยังคงอยู่",
    "delete": "ลบ",
    "deleteCustomer": "ลบลูกค้า",
    "cancel": "ยกเลิก",
    "save": "บันทึก",
    "displayName": "ชื่อที่แสดง",
    "nameRequired": "กรุณาระบุชื่อ",
    "firstName": "ชื่อจริง",
    "lastName": "นามสกุล",
    "email": "อีเมล",
    "phone": "เบอร์โทร",
    "gender": "เพศ",
    "male": "ชาย",
    "female": "หญิง",
    "other": "อื่นๆ",
    "selectGender": "เลือกเพศ",
    "birthday": "วันเกิด",
    "selectBirthday": "เลือกวันเกิด",
    "tags": "แท็ก",
    "tagsPlaceholder": "พิมพ์แล้ว Enter เพื่อเพิ่มแท็ก",
    "notes": "หมายเหตุ",
    "notesPlaceholder": "หมายเหตุเพิ่มเติม",
    "defaultRecipient": "ผู้รับเริ่มต้น",
    "recipientName": "ชื่อผู้รับ",
    "recipientRequired": "กรุณาระบุชื่อผู้รับ",
    "fullName": "ชื่อ-นามสกุล",
    "recipientPhone": "เบอร์โทรผู้รับ",
    "conversations": "การสนทนา ({{count}})",
    "unnamed": "ไม่ระบุชื่อ"
  },
  "address": {
    "addTitle": "เพิ่มที่อยู่",
    "editTitle": "แก้ไขที่อยู่",
    "save": "บันทึก",
    "cancel": "ยกเลิก",
    "label": "ชื่อที่อยู่ (label)",
    "labelExample": "เช่น บ้าน, ออฟฟิศ",
    "recipientName": "ชื่อผู้รับ",
    "recipientPhone": "เบอร์โทรผู้รับ",
    "setDefault": "ตั้งเป็นที่อยู่หลัก",
    "default": "ที่อยู่หลัก",
    "emptyValue": "ยังไม่ระบุที่อยู่",
    "edit": "แก้ไขที่อยู่",
    "deleteTitle": "ลบที่อยู่นี้?",
    "delete": "ลบที่อยู่",
    "deleteButton": "ลบ",
    "addFailed": "เพิ่มที่อยู่ไม่สำเร็จ",
    "addSuccess": "เพิ่มที่อยู่สำเร็จ",
    "editFailed": "แก้ไขที่อยู่ไม่สำเร็จ",
    "editSuccess": "แก้ไขที่อยู่สำเร็จ",
    "defaultFailed": "ตั้งที่อยู่หลักไม่สำเร็จ",
    "defaultSuccess": "ตั้งที่อยู่หลักสำเร็จ",
    "deleteFailed": "ลบที่อยู่ไม่สำเร็จ",
    "deleteSuccess": "ลบที่อยู่สำเร็จ",
    "shippingCount": "ที่อยู่จัดส่ง ({{count}})",
    "add": "+ เพิ่มที่อยู่",
    "empty": "ยังไม่มีที่อยู่จัดส่ง",
    "houseNumber": "บ้านเลขที่",
    "moo": "หมู่",
    "village": "หมู่บ้าน",
    "room": "ห้อง",
    "floor": "ชั้น",
    "soi": "ซอย",
    "road": "ถนน",
    "province": "จังหวัด",
    "district": "เขต/อำเภอ",
    "subDistrict": "แขวง/ตำบล",
    "selectProvince": "เลือกจังหวัด",
    "selectDistrict": "เลือกเขต/อำเภอ",
    "selectProvinceFirst": "เลือกจังหวัดก่อน",
    "selectSubDistrict": "เลือกแขวง/ตำบล",
    "selectDistrictFirst": "เลือกเขต/อำเภอก่อน",
    "postalCode": "รหัสไปรษณีย์",
    "postalAuto": "เติมอัตโนมัติเมื่อเลือกตำบล",
    "country": "ประเทศ",
    "previewMoo": "หมู่ {{value}}",
    "previewSoi": "ซ.{{value}}",
    "previewRoad": "ถ.{{value}}"
  },
  "validation": {
    "phone": "รูปแบบเบอร์โทรไม่ถูกต้อง"
  },
  "errors": {
    "load": "ไม่สามารถโหลดข้อมูลลูกค้าได้"
  }
}
